﻿import { DataDisplayTable } from 'components/data-display';
import { DateToLocal } from 'components/dates';
import { getEntityLocation } from 'pages/checks/utils';
import PropTypes from 'prop-types';
import React from 'react';

export function CheckSummary({ check, template, defects, loading }) {
    function generateSummaryHeaders() {

        let status = "N/A";

        if (check.passFailResult != null) {
            status = check.passFailResult.passed ? "Pass" : "Fail";
        }

        let headerData = [
            {
                header: "Location",
                value: getEntityLocation(check.entity),
                key: 'location-name'
            },
            {
                header: "Date time",
                value: (
                    <DateToLocal format="DD/MM/YYYY HH:mm">
                        {check.startDateTime}
                    </DateToLocal>
                ),
                key: 'start-date'
            },
            {
                header: "Time Taken",
                value: parseDuration(check.checkDuration),
                key: 'time-taken'
            },
            {
                header: "Status",
                value: status,
                key: 'status'
            },
            {
                header: "Template Version",
                value: `V${template.versionNumber}`,
                key: 'template-version'
            },
        ];

        if (defects.length > 0) {
            headerData.splice(headerData.length - 1, 0, {
                header: "Defects Raised",
                value: defects.length,
                key: 'defects-raised'
            })
        };

        if (check.createUser?.employeeId) {
            headerData.unshift({
                header: "Completed by",
                value: check.createUser?.fullName,
                key: 'driver-name'
            })
        } else {
            headerData.unshift({
                header: "Completed By",
                value: check.createUser?.fullName,
                key: 'completed-by'
            })
        }

        if (check.entity?.$entityType === 'Asset') {
            headerData.unshift({
                header: "Subject",
                value: check.entity?.registration,
                key: 'vehicle-reg'
            });
        }

        return headerData; 
    }

    function parseDuration(durationStr) {
        if (typeof durationStr !== 'string') return 'Invalid duration';

        const [timePart] = durationStr.split('.');
        const [h = '0', m = '0', s = '0'] = timePart.split(':');

        const hours = parseInt(h, 10) || 0;
        const minutes = parseInt(m, 10) || 0;
        const seconds = parseInt(s, 10) || 0;

        return [
          hours > 0 ? `${hours} hours` : null,
          minutes > 0 ? `${minutes} minutes` : null,
          seconds > 0 ? `${seconds} seconds` : null
        ].filter(Boolean).join(' ');
    }

    const summaryHeaders = generateSummaryHeaders();

    return (
        <div>
            <DataDisplayTable loading={loading} displayInRows={false} columnsPerRow={4} data={summaryHeaders} />
        </div>
    )
}

CheckSummary.propTypes = {
    check: PropTypes.object.isRequired,
    defects: PropTypes.array.isRequired,
    template: PropTypes.object.isRequired,
    loading: PropTypes.bool
}